import { Checkbox } from '@chakra-ui/react';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';

export interface SelectAllProps {
  isChecked: boolean | 'indeterminate';
  onChange: (checked: boolean) => void;
  disabled?: boolean;
}

const SelectAll = ({ isChecked, onChange, disabled }: SelectAllProps) => {
  const { t } = useTranslation();
  return (
    <Checkbox.Root
      cursor="pointer"
      checked={isChecked}
      // onCheckedChange={({ checked }) => onChange(checked as boolean)}
      disabled={disabled}
      _disabled={{
        cursor: 'not-allowed',
        pointerEvents: 'none',
      }}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        if (isChecked === 'indeterminate') {
          return onChange(true);
        }
        onChange(!isChecked);
      }}
      pt="3"
      size="sm"
    >
      <Checkbox.HiddenInput />
      <Checkbox.Control cursor="pointer" borderRadius="sm" tabIndex={0} />
      <Checkbox.Label>{t('filter.selectAll')}</Checkbox.Label>
    </Checkbox.Root>
  );
};

const MemoizedSelectAll = memo(SelectAll);

export { MemoizedSelectAll as SelectAll };
